let m = angular.module( 'kovForms', [] );

m.component('kovFormGroup', require('./kovFormGroup'));
m.component('kovInput', require('./kovTextInput'));
m.component('kovForm', require('./kovForm'));

module.exports = 'kovForms';